// extracted by mini-css-extract-plugin
export default {"forgotPassword":"ResetPasswordPage_forgotPassword__ai+Ug","container":"ResetPasswordPage_container__RSPpW","wrapper":"ResetPasswordPage_wrapper__d-SEG"};